import { useCallback, useEffect, useState } from "react";
import { http, getUserLabels } from "../../lib/api";
import { isTaseronRole } from "../../lib/roles";

// Projeler sayfası tanım verileri: liste + açık projenin şube/atama/toplamları; odaklanınca tazeleme
export function useProjectData(expanded) {
  const [projects, setProjects] = useState([]);
  const [regions, setRegions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [caris, setCaris] = useState([]);
  const [locs, setLocs] = useState([]);
  const [locSubs, setLocSubs] = useState({}); // şube id → taşeron adları
  const [svcTotals, setSvcTotals] = useState({}); // hizmet bazlı gelir/gider (bu proje)
  const [userLabels, setUserLabels] = useState({});
  const [appUsers, setAppUsers] = useState([]);
  useEffect(() => { getUserLabels().then(setUserLabels).catch(() => {}); }, []);
  useEffect(() => { http.get("/users").then((r) => setAppUsers(r.data.filter((u) => !isTaseronRole(u.role)))).catch(() => {}); }, []);

  const reloadServices = useCallback(() => http.get("/services").then((r) => setServices(r.data)), []);
  const reloadCategories = useCallback(() => http.get("/categories").then((r) => setCategories(r.data)), []);
  const load = useCallback(() => {
    http.get("/regions").then((r) => setRegions(r.data));
    reloadCategories();
    reloadServices();
    http.get("/caris", { params: { taseron: 1 } }).then((r) => setCaris(r.data));
    return http.get("/projects").then((r) => { setProjects(r.data); return r.data; });
  }, [reloadServices, reloadCategories]);
  useEffect(() => { load(); }, [load]);

  const loadLocs = useCallback((pid) => {
    http.get("/locations", { params: { project_id: pid } }).then((r) => setLocs(r.data));
    http.get("/assignments", { params: { project_id: pid } }).then((r) => {
      const m = {};
      r.data.forEach((a) => { if (!a.subcontractor_name) return; m[a.location_id] = m[a.location_id] || new Set(); m[a.location_id].add(a.subcontractor_name); });
      setLocSubs(Object.fromEntries(Object.entries(m).map(([k, v]) => [k, [...v].sort((x, y) => x.localeCompare(y, "tr"))])));
    });
    http.get("/services/totals", { params: { project_id: pid } }).then((r) => setSvcTotals(r.data));
  }, []);

  // başka sekmede/sayfada lokasyon eklenip silinirse odaklanınca listeleri tazele
  useEffect(() => {
    const onFocus = () => { load(); if (expanded) loadLocs(expanded); };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [expanded, load, loadLocs]);

  return { projects, regions, categories, services, caris, locs, locSubs, svcTotals, userLabels, appUsers, load, loadLocs, reloadServices, reloadCategories };
}
